import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';

export const Login = () => {
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (login(user, pass)) {
      navigate('/');
    } else {
      setError('Usuário ou senha incorretos');
    }
  };

  return (
    <div className="login-container">
      <form className="login-box" onSubmit={handleSubmit}>
        <KeyRound size={48} className="icon" />
        <h2>Login Médico</h2>
        <input placeholder="Usuário" value={user} onChange={e => setUser(e.target.value)} required />
        <input type="password" placeholder="Senha" value={pass} onChange={e => setPass(e.target.value)} required />
        {error && <p className="error">{error}</p>}
        <button type="submit">Entrar</button>
        <small>Demo: medico / senha123</small>
      </form>
    </div>
  );
};
